export default __webpack_public_path__ + "static/media/portadanuevaplanning1.6e7098f6.png";